<template>
  <div>
    <el-dialog
      title="Insert channel into blocklist"
      :visible="dialog_block"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialogBlock(false)"
    >
      <el-form label-position="top">
        <el-form-item label="This will also add the channel to the Allowlist!" prop="channel">
          <el-input placeholder="Channel ID" type="text" v-model="channel" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      channel: ''
    }
  },
  computed: {
    ...mapState('youtubeWhitelist', ['dialog_block', 'loading'])
  },

  methods: {
    ...mapActions('youtubeWhitelist', ['blockInsert']),
    ...mapMutations('youtubeWhitelist', ['setDialogBlock']),

    submit() {
      this.blockInsert(this.channel)
      this.setDialogBlock(false)
      this.channel = ''
    }
  }
}
</script>
